<template>
      <div id="actionElement" lang="ja">
        <br/>
        <div class="mdl-card mdl-shadow--2dp firebaseui-container firebaseui-id-page-email-verification-success">
          <div class="firebaseui-card-header">
            <h1 class="firebaseui-title">
              <font style="vertical-align: inherit;">
                <font style="vertical-align: inherit;">{{title}}</font>
              </font>
            </h1>
          </div>
          <div class="firebaseui-card-content">
            <p class="firebaseui-text">
              <font style="vertical-align: inherit;">
                <font style="vertical-align: inherit;">{{ msg }}</font>
              </font>
            </p>
          </div>
          <div class="firebaseui-card-actions" style="text-align: center">            
              
          </div>
        </div>
      </div>  
</template>


<script>

//import firebase from 'firebase'
import firebase from "firebase/app";
//import project from '../project.js'
require("firebaseui-ja/dist/firebaseui.css");

export default {
   name: 'signout',
   mounted: function() {

      this.$router.IsSignout = false;

      if (firebase.auth().currentUser != null){

        //移動時にログオフページに強制移動
        this.$router.IsSignout = true;
        firebase.auth().signOut().then(() => {

            this.msg = `ログオフしました`;
            // setTimeout(() => {
            //   //router.push({ name: 'user', params: { userId: 123 }})
            //   alert('sssssss');
            // }, 10000);

        })
        .catch((error) => {
          this.msg =`ログアウトできませんでした(${error})`;
        });
        
      }
      else{
        this.msg = `ログオフしました`;
      }

        //this.msg =`ログアウトできませんでした(${error})`;

    // //メール送信後
    // if ((val["mail"] || '')!=''){ 
    //     this.title = `メール送信`;

    //     if (val["mail"]=="ok"){
    //       this.msg = `確認メールを送信しました。メール認証後再度ログインしてください。`;
    //     }
    //     else{
    //       this.msg = `確認メールを送信できませんでした`;
    //     }
    // }  
                     //this.msg
   },
   data: function() {
    return {
      msg: '',
      title: '',
    }
   }
//   methods: {
//     xxx: function () {
//     }
//   }
}
</script>